/**
 * The back camera's picture (Sprint 103.0). The stream is shown in a `<video>`
 * and never read: no frame is drawn to a canvas, encoded or sent (ADR-0120 Rule 3).
 */

export async function startCamera(video: HTMLVideoElement): Promise<MediaStream | undefined> {
  if (!navigator.mediaDevices?.getUserMedia) return undefined;
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: { ideal: 'environment' } }
    });
    video.srcObject = stream;
    await video.play().catch(() => undefined);
    return stream;
  } catch {
    return undefined;
  }
}

export function stopCamera(stream: MediaStream | undefined): void {
  stream?.getTracks().forEach((track) => track.stop());
}
